import { Product } from 'idt-ecommerce-api/catalog/products/products.models';


export enum RenderStoreLocationProducts {
  PRODUCTS = 'products',
  LAST_VIEWED = 'ITX_LAST_VIEW_PRODUCTS_INFO'
}

export interface ProductLocalStore extends Product {
  defaultColor?: string;
}
